import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { setAlert } from '../../helpers/alerts';
import { createRelease } from '../../api/releases';

const TEST_INSTANCES = [
    { label: 'test-argo', value: 'om-test' },
    { label: 'test-engg', value: 'test-engg' },
];

export default function NewReleaseDialog(props) {
    const { onClose, user,  open } = props;
    const [deployTarget, setDeployTarget] = useState('om-test');

    const handleClose = () => {
        setDeployTarget('om-test');
        onClose();
    };

    const handleCreation = (params) => {
        createRelease(params).then((r) => {
            if (setAlert) {
                setAlert('New release', `Release ${r.release.version} created`, 'success');
            }
        }).catch((e) => {
            if (setAlert !== undefined){
            setAlert('Ooops', e, 'danger');
            }
        });
        handleClose();
    }

    return (
    <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
            component: 'form',
            onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                formJson.deploy_target = deployTarget;
                handleCreation(formJson);
            },
        }}
    >
        <DialogTitle sx={{fontSize: '1.5rem'}}>New release</DialogTitle>
        <DialogContent dividers>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="version"
                        label="Version"
                        type="text"
                        variant="standard"
                        fullWidth
                        sx={{"margin": "1ch 2ch 1ch 0"}}
                    />
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
                    <TextField
                        margin="dense"
                        name="source_branch"
                        label="Source Branch"
                        defaultValue="main"
                        type="text"
                        variant="standard"
                        fullWidth
                        sx={{"margin": "1ch 2ch 1ch 0"}}
                    />
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
                    <FormControl fullWidth variant="standard" sx={{"margin": "1ch 2ch 1ch 0"}}>
                        <InputLabel>Test Instance</InputLabel>
                        <Select
                            value={deployTarget}
                            onChange={(e) => setDeployTarget(e.target.value)}
                            label="Test Instance"
                        >
                            {TEST_INSTANCES.map((instance) => (
                                <MenuItem key={instance.value} value={instance.value}>
                                    {instance.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} color="error">Cancel</Button>
            <Button type="submit" color='success'>Create</Button>
        </DialogActions>
    </Dialog>);
}